import { render, staticRenderFns } from "./tjfx.vue?vue&type=template&id=12f0a8d6&scoped=true"
import script from "./tjfx.vue?vue&type=script&lang=js"
export * from "./tjfx.vue?vue&type=script&lang=js"
import style0 from "./tjfx.vue?vue&type=style&index=0&id=12f0a8d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f0a8d6",
  null
  
)

export default component.exports